import { useQuery } from '@tanstack/react-query'

import { getCardTransactionEvidenceRecordImage } from '@src/api'
import { DefaultApiGetCardTransactionEvidenceRecordImageRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchCardTransactionEvidenceRecordImage = (
  params: DefaultApiGetCardTransactionEvidenceRecordImageRequest
) => {
  const { axiosInstance } = useAxios()
  axiosInstance.defaults.responseType = 'arraybuffer'

  return useQuery({
    enabled:
      !!params.organizationId &&
      !!params.paymentReferenceId &&
      !!params.cardTransactionEvidenceId &&
      !!params.id,
    queryFn: () => getCardTransactionEvidenceRecordImage(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_CARD_TRANSACTION_EVIDENCE_RECORD_IMAGE,
      params,
    ],
  })
}
